<div class="container-fluid mt-4">
  
  <div class="row mb-3 align-items-end">
    <h4 class="col-md-4 mb-3">
      <i class="fi fi-rr-calendar"></i><span class="mx-1">კალენდარი</span>
    </h4>

    <div class="admin-calendar">
    <div class="calendar">
        <div class="header">
        <button type="button" (click)="prevMonth()">
            <i class="fi fi-tr-angle-left"></i>
        </button>

        <div class="month-label">{{ monthLabel() }}</div>

        <button type="button" (click)="nextMonth()">
            <i class="fi fi-tr-angle-right"></i>
        </button>
        </div>

        <div class="weekdays">
        <div class="weekday">ორშ</div>
        <div class="weekday">სამ</div>
        <div class="weekday">ოთხ</div>
        <div class="weekday">ხუთ</div>
        <div class="weekday">პარ</div>
        <div class="weekday">შაბ</div>
        <div class="weekday">კვი</div>
        </div>

        <div *ngIf="loading" class="grid">
        <div class="skeleton-day" *ngFor="let d of [].constructor(42)"></div>
        </div>

        <div *ngIf="!loading" class="grid">
        <div class="blank" *ngFor="let b of blanks"></div>

        <button
            type="button"
            class="day"
            *ngFor="let d of days"
            [class.has-event]="hasEvent(d)"
            [class.selected]="isSelected(d)"
            (click)="openDay(d, $event)">

            <span class="day-num">{{ d }}</span>

            <span class="event-count" *ngIf="eventCount(d) > 1">
            {{ eventCount(d) }}
            </span>
        </button>
        </div>
    </div>
    </div>

  </div>
</div>

<div class="event-popup-backdrop" *ngIf="showDayPopup" (click)="closeDayPopup()">
  <div class="event-popup admin-popup" (click)="$event.stopPropagation()">
    <div class="event-popup__header">
      <h4 class="event-popup__title">
        {{ selectedDate ? (selectedDate | date:'dd MMMM yyyy') : '' }}
      </h4>

      <div class="event-popup__actions">
        <button type="button" class="btn btn-primary" (click)="openCreateModal()">
          დამატება
        </button>
        <button type="button" class="event-popup__close" (click)="closeDayPopup()">×</button>
      </div>
    </div>

    <div class="event-popup__loading" *ngIf="loadingDayEvents">
      იტვირთება...
    </div>

    <div
      class="event-popup__list"
      *ngIf="!loadingDayEvents"
      cdkDropList
      [cdkDropListData]="dayEvents"
      (cdkDropListDropped)="drop($event)">

      <div class="event-popup__item admin-item" *ngFor="let item of dayEvents" cdkDrag>
        <div class="admin-item__drag">⋮⋮</div>

        <div class="admin-item__content">
          <div class="admin-item__title-row">
            <div class="admin-item__color" [style.background]="item.color || 'red'"></div>
            <div class="admin-item__title">
              {{ item.title_ka || item.title_en || 'უსათაურო ივენთი' }}
            </div>
          </div>

          <div class="admin-item__meta">
            {{ item.start_date }}
            <span *ngIf="item.end_date && item.end_date !== item.start_date"> - {{ item.end_date }}</span>
          </div>

          <div class="admin-item__desc" *ngIf="item.description_ka || item.description_en">
            {{ item.description_ka || item.description_en }}
          </div>

          <div class="admin-item__url" *ngIf="item.url">
            {{ item.url }}
          </div>
        </div>

        <div class="admin-item__buttons">
          <button type="button" class="btn btn-sm btn-outline-primary" (click)="openEditModal(item)">
            რედაქტირება
          </button>
          <button type="button" class="btn btn-sm btn-outline-danger" (click)="remove(item)">
            წაშლა
          </button>
        </div>
      </div>

      <div class="event-popup__empty" *ngIf="!dayEvents.length">
        ამ დღეზე ივენთი არ არის
      </div>
    </div>
  </div>
</div>

<div class="event-popup-backdrop" *ngIf="showFormModal" (click)="closeFormModal()">
  <div class="event-popup admin-form-popup" (click)="$event.stopPropagation()">
    <div class="event-popup__header">
      <h4 class="event-popup__title">
        {{ editingItemId ? 'ივენთის რედაქტირება' : 'ივენთის დამატება' }}
      </h4>
      <button type="button" class="event-popup__close" (click)="closeFormModal()">×</button>
    </div>

    <form [formGroup]="form" (ngSubmit)="save()" class="admin-form">
      <div class="form-grid">
        <input type="hidden" formControlName="start_date" />
        <input type="hidden" formControlName="end_date" />
        <input type="hidden" formControlName="sort_order" />

        <div class="form-floating">
          <input type="text" class="form-control" id="calendar-title-ka" placeholder="სათაური KA" formControlName="title_ka" />
          <label for="calendar-title-ka">სათაური ქართულად</label>
        </div>

        <div class="form-floating">
          <input type="text" class="form-control" id="calendar-title-en" placeholder="სათაური EN" formControlName="title_en" />
          <label for="calendar-title-en">სათაური ინგლისურად</label>
        </div>

        <div class="form-floating">
          <input type="text" class="form-control" id="calendar-url" placeholder="ბმული" formControlName="url" />
          <label for="calendar-url">ბმული</label>
        </div>

        <div class="form-floating">
          <select class="form-select" id="calendar-target" formControlName="target">
            <option value="_self">იმავე ფანჯარაში</option>
            <option value="_blank">ახალ ფანჯარაში</option>
          </select>
          <label for="calendar-target">გადამისამართება</label>
        </div>

        <div class="form-floating">
          <select class="form-select" id="calendar-color" formControlName="color">
            <option *ngFor="let c of colorOptions" [value]="c.value">
              {{ c.label }}
            </option>
          </select>
          <label for="calendar-color">ფერი</label>
        </div>

        <div class="form-floating form-group--full">
          <textarea class="form-control" id="calendar-description-ka" placeholder="აღწერა ქართულად" style="height: 110px" formControlName="description_ka"></textarea>
          <label for="calendar-description-ka">აღწერა ქართულად</label>
        </div>

        <div class="form-floating form-group--full">
          <textarea class="form-control" id="calendar-description-en" placeholder="აღწერა ინგლისურად" style="height: 110px" formControlName="description_en"></textarea>
          <label for="calendar-description-en">აღწერა ინგლისურად</label>
        </div>

        <div class="form-group form-group--full">
          <label class="checkbox-row">
            <input type="checkbox" formControlName="is_active" />
            აქტიური
          </label>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="btn btn-light" (click)="closeFormModal()">გაუქმება</button>
        <button type="submit" class="btn btn-primary" [disabled]="saving">
          {{ saving ? 'ინახება...' : 'შენახვა' }}
        </button>
      </div>
    </form>
  </div>
</div>